module.exports = __webpack_public_path__ + "img/gray-back.30f19188.svg";